import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-900/95 backdrop-blur-md border-t border-white/10 p-4 z-50 animate-fade-in-up">
      <div className="container mx-auto max-w-7xl flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-gray-300 text-sm text-center md:text-left">
          <p>
            Ta strona korzysta z plików cookies w celu zapewnienia najlepszej jakości usług. 
            Korzystając ze strony, zgadzasz się na ich użycie. 
            <Link to="/polityka-prywatnosci" className="text-blue-400 hover:text-blue-300 ml-1 underline transition-colors">
              Dowiedz się więcej
            </Link>.
          </p>
        </div>
        <button
          onClick={handleAccept}
          className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold rounded-full shadow-lg transition-all duration-300 hover:scale-105 whitespace-nowrap"
        >
          Akceptuję
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
